import GET_CLUSTER_ASSORTMENT_SUMMARY from './getClusterAssortmentProductsSummary.graphql'

export { GET_CLUSTER_ASSORTMENT_SUMMARY }
